module.exports = __webpack_public_path__ + "static/media/person.32557596.svg";